import { useState, useEffect } from 'react';

export const useSortFromURLParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const [sortKey] = useState(searchParams.get('sort') ?? '');
  const [sortOrder] = useState(searchParams.get('order') ?? '');
  const [filterOptionsFromUrl] = useState(() => {
    const filtersString = searchParams.get('filters');
    // eslint-disable-next-line no-extra-boolean-cast
    return !!filtersString ? JSON.parse(filtersString) : [];
  });

  useEffect(() => {
    if (sortKey || sortOrder || filterOptionsFromUrl) {
      window.history.replaceState({}, '', window.location.href.split('?')[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { sortKey, sortOrder, filterOptionsFromUrl };
};
